import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Blog() {
  const posts = [
    {
      title: 'How to Maintain Your Asphalt Driveway in Lincoln, NE',
      excerpt: 'Learn the best practices for maintaining your asphalt driveway through Nebraska\'s harsh winters and hot summers. Proper maintenance can extend your driveway\'s lifespan by 10+ years.',
      image: 'https://public.readdy.ai/ai/img_res/2acc444e2d1e1677ef7c1f30429bdb03.jpg',
      date: 'January 15, 2025',
      category: 'Maintenance',
      slug: 'maintain-asphalt-driveway-lincoln-ne',
    },
    {
      title: 'Asphalt vs Concrete: Which is Best for Your Lincoln Driveway?',
      excerpt: 'Comparing asphalt and concrete driveways for Lincoln homeowners. We break down costs, durability, maintenance, and climate considerations to help you make the right choice.',
      image: 'https://readdy.ai/api/search-image?query=side%20by%20side%20comparison%20of%20asphalt%20and%20concrete%20driveways%20showing%20different%20materials%20and%20finishes%20on%20residential%20properties%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20background&width=800&height=500&seq=26&orientation=landscape',
      date: 'January 10, 2025',
      category: 'Guides',
      slug: 'asphalt-vs-concrete-lincoln-driveway',
    },
    {
      title: 'When to Repair vs Replace Your Asphalt Driveway',
      excerpt: 'Not sure if your driveway needs repair or complete replacement? Our expert guide helps Lincoln homeowners identify damage levels and make cost-effective decisions.',
      image: 'https://readdy.ai/api/search-image?query=damaged%20asphalt%20driveway%20with%20cracks%20and%20potholes%20next%20to%20repaired%20section%20showing%20before%20and%20after%20comparison%20in%20Lincoln%20Nebraska%20with%20clean%20simple%20background&width=800&height=500&seq=27&orientation=landscape',
      date: 'January 5, 2025',
      category: 'Repair',
      slug: 'repair-vs-replace-asphalt-driveway',
    },
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-24 sm:pt-32 pb-12 sm:pb-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-primary-500 text-xs sm:text-sm mb-3 sm:mb-4 tracking-wider">Home / Blog</p>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              PAVING BLOG
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed px-4">
              Expert tips, guides, and insights on asphalt and concrete paving in Lincoln, Nebraska
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {posts.map((post, index) => (
              <Link
                key={index}
                to={`/blog/${post.slug}`}
                className="group bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-primary-600 hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 sm:h-56 md:h-64 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute top-3 sm:top-4 left-3 sm:left-4 bg-primary-600 text-white px-3 sm:px-4 py-1 rounded-full text-xs sm:text-sm font-semibold">
                    {post.category}
                  </div>
                </div>
                <div className="p-4 sm:p-6">
                  <p className="text-xs sm:text-sm text-gray-500 mb-2">{post.date}</p>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-2 sm:mb-3 text-gray-900 group-hover:text-primary-600 transition-colors leading-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                    {post.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-3 sm:mb-4 text-sm sm:text-base">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center text-primary-600 font-semibold text-sm sm:text-base">
                    <span>Read More</span>
                    <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
